import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, LogOut, Menu, Search, Settings, Tv, User } from 'lucide-react';
import { useAuth, useSettings } from '../../App';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from '../ui/dropdown-menu';
import './client.css';

export const ClientShell = ({ children, watching = false }) => {
  const { user, logout } = useAuth();
  const { platformSettings } = useSettings();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;
    const previous = viewport.getAttribute('content');
    viewport.setAttribute('content', `${previous}, viewport-fit=cover`);
    return () => viewport.setAttribute('content', previous);
  }, []);
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  const goToChannels = (search = false) => {
    document.getElementById('client-channels')?.scrollIntoView({ block: 'start' });
    if (search) document.getElementById('client-channel-search')?.focus({ preventScroll: true });
  };
  const adminLink = user?.role === 'superadmin' ? '/superadmin/settings' : '/admin';
  const adminLabel = user?.role === 'superadmin' ? 'Configurações' : 'Painel Admin';
  const hasAdminLink = user?.role === 'superadmin' || user?.role === 'admin';

  return (
    <div className="client-shell bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900" data-testid="client-shell">
      <header className="client-header" data-testid="client-header">
        <div className="client-header-start">
          <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="client-icon-button" aria-label="Menu" title="Menu" data-testid="client-header-menu">
                <Menu aria-hidden="true" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" sideOffset={12} collisionPadding={16} className="client-menu" data-testid="client-menu">
              <DropdownMenuLabel className="client-menu-user" data-testid="client-menu-user"><User aria-hidden="true" />{user?.full_name}</DropdownMenuLabel>
              <DropdownMenuItem asChild data-testid="client-menu-channels"><Link to="/dashboard"><Tv aria-hidden="true" />Canais Disponíveis</Link></DropdownMenuItem>
              {hasAdminLink && <DropdownMenuItem asChild data-testid="client-menu-admin"><Link to={adminLink}><Settings aria-hidden="true" />{adminLabel}</Link></DropdownMenuItem>}
              <DropdownMenuItem onSelect={handleLogout} data-testid="client-menu-logout"><LogOut aria-hidden="true" />Sair</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          {watching && <Button variant="ghost" onClick={() => navigate('/dashboard')} className="client-back-button" title="Voltar" aria-label="Voltar" data-testid="client-back"><ArrowLeft aria-hidden="true" /><span>Voltar</span></Button>}
        </div>
        <Link to="/dashboard" className="client-brand" aria-label={platformSettings?.platform_name || 'DIGITAL TV PLAY'} data-testid="client-brand">
          {platformSettings?.logo_url && !logoFailed ?
            <img src={platformSettings.logo_url} alt={platformSettings.platform_name} onError={() => setLogoFailed(true)} data-testid="client-brand-logo" /> :
            <span><Tv aria-hidden="true" />{platformSettings?.platform_name || 'DIGITAL TV PLAY'}</span>}
        </Link>
        <div className="client-header-actions">
          <span className="client-header-user" data-testid="client-user-name"><User aria-hidden="true" />{user?.full_name}{user?.role === 'admin' && <small data-testid="client-user-role">Admin</small>}</span>
          {hasAdminLink && <Button variant="ghost" asChild className="client-desktop-action client-icon-button"><Link to={adminLink} aria-label={adminLabel} title={adminLabel} data-testid="client-header-admin"><Settings aria-hidden="true" /></Link></Button>}
          <Button variant="ghost" onClick={handleLogout} className="client-icon-button" aria-label="Sair" title="Sair" data-testid="client-header-logout"><LogOut aria-hidden="true" /></Button>
        </div>
      </header>
      {children}
      <nav className="client-bottom-nav" aria-label="Navegação do cliente" data-testid="client-bottom-navigation">
        <Button variant="ghost" className="client-bottom-action" onClick={() => goToChannels()} data-testid="client-bottom-channels"><Tv aria-hidden="true" /><span>Canais</span></Button>
        <Button variant="ghost" className="client-bottom-action" onClick={() => goToChannels(true)} data-testid="client-bottom-search"><Search aria-hidden="true" /><span>Buscar</span></Button>
        <Button variant="ghost" className="client-bottom-action" onClick={() => setMenuOpen(true)} aria-expanded={menuOpen} aria-haspopup="menu" data-testid="client-bottom-menu"><Menu aria-hidden="true" /><span>Menu</span></Button>
      </nav>
    </div>
  );
};